import EditorToolbar from './components/EditorToolbar';

const EDITOR_TOOLBAR_NAME = EditorToolbar.NAME;

export { default } from './FileToolbar';
export { EDITOR_TOOLBAR_NAME };
